import { useAvailableLocale } from 'hooks/localisation/useAvailableLocale';
import { useLocalStorage, UserLocale } from 'hooks/userPreferences';
import { DEFAULT_LOCALE_INFO } from 'lib/constants/siteDefaults';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const QueryParamLocaleSelector = () => {
  const { setStoredValue: setUserSiteLocale } = useLocalStorage(UserLocale);
  const { getAvailableLocale } = useAvailableLocale();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams) {
      const countryParam = searchParams.get('country');

      if (countryParam && setUserSiteLocale) {
        const availableLocale = getAvailableLocale(countryParam);

        // If there's no availableLocale, we want to show defaults
        setUserSiteLocale(availableLocale || DEFAULT_LOCALE_INFO);
      }
    }
  }, [searchParams, getAvailableLocale, setUserSiteLocale]);

  return null;
};
